import axios from 'axios';


const server = axios.create({
    baseURL: "",
    headers: {
        'Content-Type': 'application/json'
    }
});

// EMULACION del Android bridge local (localhost:5180) para poder probar el flujo completo sin el
// ejecutable puente ni el dispositivo Android fisico conectados. Se llama en cada seleccion de
// producto (VendingMenu.getGroupById -> getRunningstate), asi que sin esto cada click a un producto
// vuelve a marcar la maquina como "fuera de servicio". Para volver a pegarle al bridge real, cambia
// esta constante a `false`.
const EMULATE_ANDROID_BRIDGE = false;

export class VendingAndroidFetchAPI {
    /*  static async getHealth(ip) {
          let response = await server.get(`http://${ip}:9091/health`);
          return response;
      }
  
      static async getRunningState(ip) {
          let response = await server.get(`http://${ip}:9091/runningstate`, {
          headers: {
              'x-api-key': "CAMBIA_ESTE_TOKEN_LARGO_2026" // o el token literal si lo pruebas
          }
      } );
          return response;
      }
  
      static async getdiagnostics(ip) {
          let response = await server.get(`http://${ip}:9091/bvm/diagnostics`);
          return response;
      }
  
      static async generalFunctionVending(ip, data) {
      // No conviertas a JSON manualmente, deja que Axios lo haga
      let response = await server.post(`http://${ip}:9091/despachar`, data, {
          headers: {
              'x-api-key': "CAMBIA_ESTE_TOKEN_LARGO_2026" // o el token literal si lo pruebas
          }
      });
      return response;
  }*/



    static async getHealth(ip) {
        if (EMULATE_ANDROID_BRIDGE) {
            return { data: { status: "ok" } };
        }
        let bodyData = {
            Ruta: `http://${ip}:9091/health`,
            payload: {},
            header: {},
            method: "get"
        }
        let res = await server.post(` http://localhost:5180/androidbridge`, bodyData);
        let dataResponse = {data: res.data.upstreamBody}
        return dataResponse
    }

    static async getRunningState(ip) {
        if (EMULATE_ANDROID_BRIDGE) {
            // runningState == 2 es lo que getRunningstate() interpreta como "maquina lista"
            return { data: { runningState: 2 } };
        }
        let bodyData = {
            Ruta: `http://${ip}:9091/runningstate`,
            payload: {},
            header: {
                'x-api-key': "CAMBIA_ESTE_TOKEN_LARGO_2026" // o el token literal si lo pruebas
            },
            method: "get"
        }
        let res = await server.post(` http://localhost:5180/androidbridge`, bodyData);
        let dataResponse = {data: res.data.upstreamBody}
        return dataResponse
    }

    static async getdiagnostics(ip) {
        if (EMULATE_ANDROID_BRIDGE) {
            return { data: {} };
        }
        let bodyData = {
            Ruta: `http://${ip}:9091/bvm/diagnostics`,
            payload: {},
            header: {},
            method: "get"
        }
        let res = await server.post(` http://localhost:5180/androidbridge`, bodyData);
        let dataResponse = {data: res.data.upstreamBody}
        return dataResponse
    }




    static async generalFunctionVending(ip, data) {
        if (EMULATE_ANDROID_BRIDGE) {
            if (data && data.funcion === "GETTEMP") {
                // getTempAndorid espera data.data = [temp, _, _, humedad]
                return { data: { data: ["5", "0", "0", "45"] } };
            }
            if (data && data.funcion === "DESPACHAR") {
                return { data: { ResultadoDespachado: { totalResult: 0 } } };
            }
            return { data: { data: [] } };
        }

        let bodyData = {
            "ruta": "http://"+ip+":9091/despachar",
            "payload": data,
            "header": {
                'x-api-key': "CAMBIA_ESTE_TOKEN_LARGO_2026" // o el token literal si lo pruebas
            },
            "method": "post"
        }
        let res = await server.post(` http://localhost:5180/androidbridge`, bodyData);

        let dataResponse = {data: res.data.upstreamBody}
        return dataResponse
    }


    static async maintenancestatus() {
        if (EMULATE_ANDROID_BRIDGE) {
            return { data: { message: "Maquina operativa (emulado)", maintenance: false } };
        }
        let res = await server.get(` http://localhost:5180/maintenance/status`, {
          headers: {
              'X-SmartPay-Key': "change-this-local-key" // o el token literal si lo pruebas
          }});

        return res
    }

    static async maintenanceEnter() {
        if (EMULATE_ANDROID_BRIDGE) {
            return { data: { message: "Modo mantenimiento activado (emulado)" } };
        }
        let res = await server.post(` http://localhost:5180/maintenance/enter`, {}, {
          headers: {
              'X-SmartPay-Key': "change-this-local-key" // o el token literal si lo pruebas
          }});


        return res
    }

    static async maintenanceExit() {
        if (EMULATE_ANDROID_BRIDGE) {
            return { data: { message: "Modo mantenimiento desactivado (emulado)" } };
        }
        let res = await server.post(` http://localhost:5180/maintenance/exit`, {}, {
          headers: {
              'X-SmartPay-Key': "change-this-local-key" // o el token literal si lo pruebas
          }});


        return res
    }






}